<template>
  <v-toolbar app color="white">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon outline color="primary" v-on="on" @click="onGoBackClick">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </template>
      {{ $t('go-back-btn') }}
    </v-tooltip>
    <v-toolbar-title>
      <template v-if="title">{{ title }}</template>
      <template v-else>{{ addLabel }}</template>
    </v-toolbar-title>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    addLabel: {
      type: String,
      required: true
    }
  },
  methods: {
    onGoBackClick: function() {
      this.$router.go(-1)
    }
  }
}
</script>